import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  COMPLETE_BUTTON: `${cleanedFilename(__filename)}-complete-button`,
};
